import { logger } from '@src/app/logger';
import { getShellConfig } from '@src/config/shell/config';

/**
 * Removes the category name, which can occur as a prefix in the tournament
 * name, from the tournament name. This gives us a simplified and streamlined
 * name and takes less space.
 *
 * It is enabled by a Directus CMS config, because it needs coordination
 * with the Stats MFE (gradual and timed release, in this case).
 *
 * When disabled (default), it returns the original tournament name.
 * In case of failure, logs an error and returns the original as well.
 *
 * @param tournamentName Full tournament name as defined in Bookie
 * @param categoryName Category name
 * @returns Tournament name with stripped category name prefix, if any
 */
export function simplifyTournamentName(
    tournamentName: string,
    categoryName: string,
): string {
    try {
        const shellConfig = getShellConfig();
        const useSimplifiedName = shellConfig.remoteConfig.sportsOffer.useSimplifiedTournamentName;

        if (!useSimplifiedName) {
            return tournamentName;
        }

        let simplifiedName = tournamentName.replace(
            new RegExp(`^${categoryName}[^\\w]+`, 'i'),
            '',
        );

        simplifiedName = simplifiedName.replace(/,/g, '');

        // Specific edge case found in the offer, where it marks
        // a year or section, so we'd just be left with a number
        // if we didn't have this case
        if (/^\d+$/.test(simplifiedName)) {
            return tournamentName;
        } else {
            return simplifiedName;
        }
    } catch (e) {
        logger.error(new Error('Could not simplify tournament name'));
        return tournamentName;
    }
}
